import { render, staticRenderFns } from "./IndexSearch.vue?vue&type=template&id=b91afa2e&scoped=true&"
import script from "./IndexSearch.vue?vue&type=script&lang=js&"
export * from "./IndexSearch.vue?vue&type=script&lang=js&"
import style0 from "./IndexSearch.vue?vue&type=style&index=0&id=b91afa2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b91afa2e",
  null
  
)

export default component.exports